import React from "react";

// ==== Import Images ====
import img08 from "../../../images/bg/AboutHEro/2.png";

import featureIcon1 from "../../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../../images/icon/feature-icon03.svg";

import aboutBg from "../../../images/bg/about-bg02.png";

const AboutSection: React.FC = () => {
  return (
    <section className="about pos-rel pb-140">

      <div className="container">
        
<div className="about-top-image ul_li_between align-items-start">
  <div className="about-hero-img">
    <img src={img08} alt="About Hero" />
  </div>
</div>


        {/* ===== Title Section ===== */}
<div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
  <span className="sub-title mb-10">Who We Are</span>

  <h2 className="title">
    We help{" "}
    {/* <span><img src={gif1} alt="gif" /></span> */}
    businesses build trust and{" "}
    {/* <span><img src={gif2} alt="gif" /></span> */}
    scale faster with secure,{" "}
    {/* <span><img src={gif3} alt="gif" /></span> */}
    blockchain-powered solutions.
  </h2>

  <p className="content">
    We are a blockchain technology company delivering end-to-end solutions for
    businesses across industries. From smart contract development and decentralized
    applications to enterprise blockchain integration and security audits, we help
    organizations adopt blockchain with confidence. Our focus is on building
    transparent, secure, and scalable systems that drive real-world value and long-term
    growth.
  </p>
</div>


        {/* ===== Feature Boxes ===== */}
        <div className="row mt-40">
  {/* 1 */}
  <div className="col-lg-4 col-md-6 mt-30">
    <div className="xb-feature-item">
      <div className="xb-item--inner xb-border">
        <span className="xb-item--icon">
          <img src={featureIcon1} alt="icon" />
        </span>
        <div className="xb-item--holder">
          <h2 className="xb-item--title">Trusted systems</h2>
          <p className="xb-item--content">
            Build transparent blockchain networks designed for real-world business use.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* 2 */}
  <div className="col-lg-4 col-md-6 mt-30">
    <div className="xb-feature-item">
      <div className="xb-item--inner xb-border">
        <span className="xb-item--icon">
          <img src={featureIcon2} alt="icon" />
        </span>
        <div className="xb-item--holder">
          <h2 className="xb-item--title">Blockchain integration</h2>
          <p className="xb-item--content">
            Seamlessly integrate blockchain into your existing systems without complexity.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* 3 */}
  <div className="col-lg-4 col-md-6 mt-30">
    <div className="xb-feature-item">
      <div className="xb-item--inner xb-border">
        <span className="xb-item--icon">
          <img src={featureIcon3} alt="icon" />
        </span>
        <div className="xb-item--holder">
          <h2 className="xb-item--title">Secure automation</h2>
          <p className="xb-item--content">
            Automate processes using smart contracts that execute reliably without intermediaries.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

      </div>

      {/* Background */}
      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
